import React from 'react';
import Text from '../../../Text';
import './_card-caption.scss';








const CardCaption = ({ text, subtitle, fileExtension = '', children }) => {
  if (children) {return children;}

  return (
    <div className="card-caption">
      <div className="card-caption__text">
        <Text noMargin heading4 ellipsisOverflow className="card-caption__text__title">{text}</Text>
        {
        fileExtension &&
        <Text noMargin heading4 className="card-caption__text__extension">
              {`.${fileExtension}`}
            </Text>}


      </div>
      {subtitle ? <Text timestamp>{subtitle}</Text> : null}
    </div>);

};

export default CardCaption;